module.exports = __webpack_public_path__ + "static/img/mrukwa-kominek.0ec7708.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mrukwa-kominek.png
// module id = L1gR
// module chunks = 1